<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-four-k`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 6H4a2 2 0 00-2 2v26a2 2 0 002 2h18v2H11a1 1 0 00-1 1v2a1 1 0 001 1h26a1 1 0 001-1v-2a1 1 0 00-1-1H26v-2h18a2 2 0 002-2V8a2 2 0 00-2-2zM6 32V10h36v22H6zm21-17a1 1 0 011-1h2a1 1 0 011 1v3.172l3.707-3.708a1 1 0 011.414 0l1.414 1.415a1 1 0 010 1.414L33.828 21l3.707 3.707a1 1 0 010 1.414l-1.414 1.415a1 1 0 01-1.414 0L31 23.828V27a1 1 0 01-1 1h-2a1 1 0 01-1-1V15zm-16-1a1 1 0 00-1 1v7a1 1 0 001 1h7v4a1 1 0 001 1h2a1 1 0 001-1V15a1 1 0 00-1-1h-2a1 1 0 00-1 1v4h-4v-4a1 1 0 00-1-1h-2z"/></svg>
</template>
<script>

export default {
  name: 'IconFourK',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
